import React from 'react';
import PropTypes from 'prop-types';
import popupTools from 'popup-tools';
import queryString from 'querystring';
import styled from 'styled-components';

import Button from '@prisjakt/ui-button';
import FacebookBox from 'mdi-react/FacebookBoxIcon';
import TwitterBox from 'mdi-react/TwitterBoxIcon';
import { colorUtils } from '@prisjakt/ui-base';

const serviceMap = {
  facebook: '#3b5998',
  twitter: '#00aced',
};

export const ServiceButton = styled(Button)`
  background: ${p => serviceMap[p.service]};
  &:hover {
    background: ${p => colorUtils.shadeColor(serviceMap[p.service], 10)};
  }
`;

class ExternalButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      didRespond: false,
    };
  }

  render() {
    const { service, text, onAuth } = this.props;

    const qs = queryString.encode({
      createAccount: this.props.createAccount,
      acceptTerms: this.props.acceptTerms,
      newsLetter: this.props.newsLetter,
    });

    const networkIcon = network => {
      switch (network) {
        case 'facebook':
          return <FacebookBox />;
        case 'twitter':
          return <TwitterBox />;
        default:
          return null;
      }
    };

    return (
      <ServiceButton
        service={service}
        style={{ width: '100%' }}
        color="primary"
        iconPosition="left"
        icon={networkIcon(service)}
        onClick={() => {
          this.setState({
            didRespond: false,
          });
          this.props.onInit();

          popupTools.popup(
            `${window.INTERNAL_HOSTNAME}/_internal/auth/${service}/authorize?${qs}`,
            '',
            {},
            (err, result) => {
              // This callback is triggered multiple times for some reason
              // Emit only response ones
              if (this.state.didRespond) {
                return;
              }

              this.setState({
                didRespond: true,
              });

              if (err instanceof Error) {
                onAuth({
                  // Format human readable message as error code. This is a
                  // bit brittle, but we can't catch this error otherwise:
                  // Eg 'Popup Closed' -> 'auth.popup-closed'.
                  code: `auth.${err.message.toLowerCase().replace(' ', '-')}`,
                });
                return;
              }

              if (err) {
                onAuth(err);
                return;
              }

              if (result.error) {
                onAuth(result.error);
                return;
              }

              onAuth(null, result);
            }
          );
        }}
      >
        {text}
      </ServiceButton>
    );
  }
}

ExternalButton.propTypes = {
  service: PropTypes.oneOf(['facebook', 'twitter']).isRequired,
  onAuth: PropTypes.func,
  onInit: PropTypes.func,
  text: PropTypes.string,
  createAccount: PropTypes.bool.isRequired,
  acceptTerms: PropTypes.bool.isRequired,
  newsLetter: PropTypes.bool.isRequired,
};

ExternalButton.defaultProps = {
  onAuth: () => {},
  onInit: () => {},
  text: null,
};

export default ExternalButton;
